import { Directive, HostListener, Input, Output, EventEmitter, ElementRef, AfterViewInit, OnInit, OnDestroy, Inject, ChangeDetectorRef } from '@angular/core';
import { WindowRef, BrowserUtils } from '../../core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';

class SmPingHelper {
	public static getTopPosition(elementRef: ElementRef, windowRef: WindowRef): number {
		const w = windowRef.nativeWindow;
		const e = elementRef.nativeElement;
		const de = w.document.documentElement;

		const box = e.getBoundingClientRect();
		const top = box.top + w.pageYOffset - de.clientTop;

		return top;
	}
}

@Directive({
	selector: '[smPinContainer]',
	exportAs: 'smPinContainer'
})
export class SmPinContainerDirective {
	constructor(
		private _elementRef: ElementRef,
		private _windowRef: WindowRef) { }

	getWidth(): number {
		return this._elementRef.nativeElement.offsetWidth;
	}

	getTopPosition(): number {
		return SmPingHelper.getTopPosition(this._elementRef, this._windowRef);
	}
}

@Directive({
	selector: '[smPin]',
	exportAs: 'smPin',
	host: {
		'[class.sm-pin-pinned]': 'pinned',
		'[class.sm-fixed]': 'isFixed()',
		'[style.width]': 'getWidth()'
	}
})
export class SmPinDirective implements AfterViewInit, OnDestroy {
	private _toggleElement: any;
	private _isFixed = false;
	private _interval: any;
	private _checkInterval: any;
	private _timer: any;
	private _width: string = 'auto';

	@Input() pinned: boolean;
	@Output() pinnedChange: EventEmitter<boolean> = new EventEmitter();

	constructor(
		private _elementRef: ElementRef,
		private _windowRef: WindowRef,
		private _container: SmPinContainerDirective,
		private _cd: ChangeDetectorRef,
		@Inject(PLATFORM_ID) private _platformId: any) { }

	ngAfterViewInit() {
		this._computeIsFixed();

		if (isPlatformBrowser(this._platformId)) {
			this._watchDocumentHeight();
			this._checkInterval = setInterval(() => this._computeIsFixed(), 100);
		}

		this._cd.detectChanges();
	}

	ngOnDestroy() {
		if (this._interval) {
			clearInterval(this._interval);
		}
		if (this._checkInterval) {
			clearInterval(this._checkInterval);
		}
	}

	toggle() {
		this.pinned = !this.pinned;
		this._computeIsFixed();

		if (this.pinnedChange) {
			this.pinnedChange.emit(this.pinned);
		}
	}

	@HostListener('window:resize', ['$event'])
	@HostListener('window:scroll', ['$event'])
	onScrollOrResize(event) {
		clearTimeout(this._timer);

		this._timer = setTimeout(() => {
			this._computeIsFixed();
		}, 20);
	}

	set toggleElement(toggleElement: any) {
		this._toggleElement = toggleElement;
	}

	getWidth(): string {
		return this._width;
	}

	isFixed(): boolean {
		return this._isFixed;
	}

	private _watchDocumentHeight() {
		const w = this._windowRef.nativeWindow;
		let h = 0;
		let hfn = () => {
			let nh = w.document.body.scollHeight;
			if (h != nh) {
				h = nh;
				this._computeIsFixed();
			}
		};

		this._interval = setInterval(hfn, 100);
	}

	private _computeIsFixed() {
		if (!this.pinned) {
			if (this._container && this._windowRef.nativeWindow) {
				const w = this._windowRef.nativeWindow;
				const wh = w.innerHeight + w.pageYOffset;
				const top = this._container.getTopPosition() || 0;

				if (top >= wh) {
					this._isFixed = true;
					this._width = this._container.getWidth() + 'px';
					return;
				}
			}
		}

		this._isFixed = false;
		this._width = 'auto';
	}
}

@Directive({
	selector: '[smPinToggle]',
	host: {
		'class': 'sm-pinn-toggle',
		'[class.is-pinned]': 'isPinned()',
		'(click)': 'toggle()'
	}
})
export class SmPinToggleDirective {
	constructor(public pinn: SmPinDirective, elementRef: ElementRef) {
		pinn.toggleElement = elementRef;
	}

	isPinned() {
		return this.pinn.pinned;
	}

	toggle() {
		this.pinn.toggle();
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/directives/sm-pin.directive.ts